export default __webpack_public_path__ + "static/media/formulas.ff925f65.png";